const toolbar_styles = {
  minHeight: {
    xs: "17rem",
    sm: "13rem",
    md: "9rem",
    lg: "5rem",
  },
};

export const ToolbarStyles = toolbar_styles;

const projectCard_Styles = {
  marginTop: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  marginLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  marginRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  width: {
    xs: "85%",
    sm: "87.5%",
    md: "90%",
    lg: "92.5%",
  },
  height: {
    xs: "14rem",
    sm: "16rem",
    md: "18rem",
    lg: "20rem",
  },
  display: 'flex',
  flexDirection: "column",
  justifyContent: "space-between",
  
};

export const ProjectCardStyles = projectCard_Styles;

const nameStyles = {
  textAlign: "left",
  width: 1,
  fontSize: "24px"
};

export const NameStyles = nameStyles;


const timeframeStyles = {
  textAlign: "right",
  width: 1,
  fontSize: "22px"
};

export const TimeframeStyles = timeframeStyles;

const descriptionStyles = {
  fontSize: "20px"
}

export const DescriptionStyles = descriptionStyles;